import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'App.CreateCommunication.Title',
    defaultMessage: 'Fortress - Create Communication',
  },
  viewTitle: {
    id: 'App.CreateCommunication.viewTitle',
    defaultMessage: 'Fortress - View Communication',
  },
  prospectDisclaimer: {
    id: 'App.CreateCommunication.prospectDisclaimer',
    defaultMessage:
      'To text Prospects, you may only select one prospect at a time.',
  },
  noPhoneNumber: {
    id: 'App.CreateCommunication.NoPhoneNumber',
    defaultMessage:
      "The property doesn't have a phone number assigned for texting. Please contact your administrator.",
  },
  marketingToggleLabel: {
    id: 'App.CreateCommunication.marketingToggleLabel',
    defaultMessage: 'Marketing & Promotions',
  },
  marketingToggleTooltip: {
    id: 'App.CreateCommunication.marketingToggleTooltip',
    defaultMessage:
      'Use this setting when your message includes promotional content such as special offers, ' +
      'referral incentives, community events, or announcements about new amenities. ' +
      'Leave this box unchecked for operational messages like rent reminders, service updates, ' +
      'or leasing communications.',
  },
  preferenceValidationError: {
    id: 'App.CreateCommunication.preferenceValidationError',
    defaultMessage:
      'Some recipients have opted out of marketing messages. They will not receive this communication.',
  },
  lettersUnavailable: {
    id: 'App.CreateCommunication.LettersUnavailable',
    defaultMessage: 'Letters are not available for Applicants or Prospects.',
  },
});

export default messages;
